@if (!isDismissed) {
  <div [class]="'notification' + ' ' + color + ' ' + size">
    @if (headline || isDismissible) {
      <div class="d-flex align-items-center justify-content-between mb-2">
        @if (headline) {
          <div class="headline">{{ headline }}</div>
        }
        @if (isDismissible) {
          <web-design-system-icon name="cross" [color]="color" (click)="dismiss()" />
        }
      </div>
    }
    <div class="text">
      <ng-content />
    </div>
  </div>
}
